/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Row, Col } from 'react-bootstrap';

import Features from '../Features';
import s from './Pricing.scss';

const messages = defineMessages({
  header: {
    id: 'product.pricing.header',
    defaultMessage: 'Pricing Overview',
    description: 'Label for pricing header title in product pricing',
  },
  buyNow: {
    id: 'product.pricing.buyNow',
    defaultMessage: 'GO GET IT',
    description: 'Label for buy now button in product pricing',
  },
});

class Pricing extends React.Component {
  static propTypes = {
    pricing: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.any,
        monthlyPrice: PropTypes.any,
        monthlyPayment: PropTypes.any,
        limitMessage: PropTypes.any,
        featureHeaderText: PropTypes.any,
        featureList: PropTypes.array,
        notesList: PropTypes.array,
        buyLink: PropTypes.string,
      }),
    ).isRequired,
  };

  static defaultProps = {
    limitMessage: null,
    notesList: null,
  };

  constructor(props) {
    super(props);

    this.renderPricing = this.renderPricing.bind(this);
  }

  // eslint-disable-next-line class-methods-use-this
  renderPricing(pricing, index) {
    const pricingCount = this.props.pricing.length;
    const {
      title,
      limitMessage,
      featureHeaderText,
      featureList,
      notesList,
      buyLink,
    } = pricing;
    const bootstrapSize = pricingCount > 0 ? 12 / pricingCount : 1;
    return (
      <Col xs={12} sm={bootstrapSize} key={`pricing-${index}`}>
        <h4>
          <FormattedMessage {...title} />
        </h4>
        <span className={s.price}>
          {limitMessage &&
            <span className="small semi-light-grey">
              <FormattedMessage {...limitMessage} />
            </span>}
          {!limitMessage &&
            <span
              className="small semi-light-grey"
              style={{ visibility: 'hidden' }}
            >
              No limit
            </span>}
        </span>
        <Features
          featureHeaderText={featureHeaderText}
          featureList={featureList}
          notesList={notesList}
          collapsible
        />
        <a
          href={buyLink}
          target={'_blank'}
          rel="noopener noreferrer"
          className="btn btn-teal btn--small"
        >
          <FormattedMessage {...messages.buyNow} />
        </a>
        <Features
          featureHeaderText={featureHeaderText}
          featureList={featureList}
          notesList={notesList}
        />
      </Col>
    );
  }

  render() {
    const { pricing } = this.props;
    return (
      <div className={s.pricingContainer}>
        <h3>
          <FormattedMessage {...messages.header} />
        </h3>
        <div className={s.pricingContentContainer}>
          <div className={s.content}>
            <Row className={s.licenses}>
              {pricing.map(this.renderPricing)}
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Pricing);



// WEBPACK FOOTER //
// ./src/components/ProductPage/Pricing/index.js